import React from 'react'
import { useState } from 'react';
import '../index.css';

const Card = ({id, name, info, image, price, removeTour }) => {
    const [readmore, setReadmore] = useState(false);
    const description = readmore ? info : `${info.substring(0,200)}....`;

    function handleReadMore(){
      setReadmore(!readmore);
    }

  return (
    <div className='card'>
      <div>
        <img src={image} alt='' className='image'></img>
      </div>
      <div className='tour-info'>
          <div className='tour-details'>
            <h4 className='tour-price'> ₹ {price}</h4>
              <h4 className='tour-name'>{name}</h4>
      </div> 
     
      <div className='description'>{description}
      <span className='read-more' onClick={handleReadMore}>
      {readmore ? 'Show less' : 'Read more' }
        </span>
        </div>
      </div>

      <button className='btn-red' onClick={()=>removeTour(id)}>Not Interested</button>
    </div>
  )
}

export default Card
